import { render, staticRenderFns } from "./KpiTargets.vue?vue&type=template&id=01e6b6d7&"
import script from "./KpiTargets.vue?vue&type=script&lang=js&"
export * from "./KpiTargets.vue?vue&type=script&lang=js&"
import style0 from "./KpiTargets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports